import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faFacebookF, faInstagram, faYoutube, faTelegramPlane, faLinkedin, faXTwitter, faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import {
    faCheck, faTimes, faPlay, faPause, faEnvelope, faCommentDots, faUser, faLock, faChevronRight, faChevronLeft, faPrint, faSignOutAlt, faPhone,
} from '@fortawesome/free-solid-svg-icons';
import {
    faFilePdf
} from '@fortawesome/free-regular-svg-icons';

library.add(faFacebookF, faInstagram, faYoutube, faTelegramPlane, faXTwitter, faLinkedin, faWhatsapp, faCheck, faTimes, faPlay, faPause, faEnvelope, faCommentDots, faUser, faLock, faChevronRight, faChevronLeft, faFilePdf, faPrint, faSignOutAlt, faPhone);
